import { useColorModeValue } from "@chakra-ui/react";

export function useTagBackgroundColor() {
    return useColorModeValue("blue.50", "gray.700");
}

export function useTagTextColor() {
    return useColorModeValue("blue.700", null);
}